// extracted by mini-css-extract-plugin
export default {"radio-option":"RadioOption_radio-option__hLgdK"};